var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_524)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.0001,
    cy: 20,
    r: 33.3333,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 9.88641C17.0593 9.88641 14.6667 12.2789 14.6667 15.2197C14.6667 18.1605 17.0593 20.5531 20.0001 20.5531C22.9409 20.5531 25.3334 18.1605 25.3334 15.2197C25.3334 12.2789 22.9409 9.88641 20.0001 9.88641Z",
    fill: "#15389C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6357 24.0373C25.1755 22.5548 23.2398 21.7383 21.1852 21.7383H18.8148C16.7602 21.7383 14.8244 22.5548 13.3643 24.0373C11.9113 25.5127 11.1111 27.4601 11.1111 29.521C11.1111 29.8483 11.3764 30.1136 11.7037 30.1136H28.2963C28.6235 30.1136 28.8889 29.8483 28.8889 29.521C28.8889 27.4601 28.0887 25.5127 26.6357 24.0373Z",
    fill: "#15389C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/profileAvatar.a277318c443840ba265bb0e771f82197.svg";
export { ForwardRef as ReactComponent };